import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si soy tímido o no soy bueno escribiendo?',
  a: 'Sí. El Protocolo 3C está diseñado específicamente para hombres que no saben por dónde empezar. No necesitás ser carismático ni tener habilidades previas. El sistema te da la estructura paso a paso para que lo apliques aunque nunca hayas tenido un chat que funcione.'
}, {
  q: '¿Tengo que escribir mucho para que funcione?',
  a: 'No. De hecho, uno de los errores más comunes es escribir demasiado. El Protocolo 3C te enseña a comunicar más con menos. Mensajes cortos, con intención y en el momento justo funcionan 10 veces mejor que párrafos largos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de confirmar tu pago, recibís un email con el acceso a todos los PDFs. En menos de 5 minutos ya podés estar leyendo el primer tomo.'
}, {
  q: '¿En cuánto tiempo puedo notar resultados?',
  a: 'La mayoría de los hombres nota un cambio en la calidad de sus conversaciones desde el primer chat que aplican el método. Los resultados concretos (citas coordinadas) dependen de la práctica, pero con el plan de implementación incluido, el objetivo son resultados visibles en 21 días.'
}, {
  q: '¿Me van a decir "estoy ocupada" igual después de aplicarlo?',
  a: 'El Tomo 9 está completamente dedicado al manejo de objeciones. Aprendés las respuestas exactas para cada excusa y cómo distinguir un "no real" de un "no por mal timing". La mayoría de los "estoy ocupada" son recuperables con la respuesta correcta.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="rx853n2mbyar">
      <div className="mx-auto max-w-3xl px-5 py-20 pt-[32px] pb-[0px]" data-id="element-52" data-mp="wynrbigj8auq">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="iy4n6mf6toxu">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="mz6r3gk1up65">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="2kulwumufurfx" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03]" data-id="element-56" data-mp="2fwtueyw63mxh">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-57" data-mp="38l989i3kbz78">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" data-id="element-58" data-mp="33mo6he8nx7go" /> : <PlusIcon className="h-5 w-5 shrink-0 text-azul-soft" data-id="element-59" data-mp="33n7lam30nfqh" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="2ylib18nmb63g">
                  <div className="overflow-hidden" data-id="element-61" data-mp="1n8epx6anwn0e">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="1n622weq1rmgh">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}